module.exports = __webpack_public_path__ + "static/siyata-245d28a0445608d209508ecbeb868f9e.png";